module.exports = __webpack_public_path__ + "static/media/ffsp-logo_dark.b73968fd.png";